module.exports = __webpack_public_path__ + "img/Azih.f8eab016.jpg";